module.exports = __webpack_public_path__ + "static/media/pharmacodb-logo.3d66b039.png";